'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import { SMART_CAPABLE_WIDGET_TYPES } from 'ContentEditorUI/lib/widgetEdit/constants';
export const isSmartEnabled = (type, module, isCmv2) => {
  if (ImmutableMap.isMap(module)) {
    module = module.toJS();
  }
  const content = module.data || module.body;
  const smartObjects = module.smart_objects;
  if (type === 'rich_text' && module.name === 'post_body' && module.__hs_internal) {
    return false;
  }
  if (type === 'form' && content) {
    return !!content.form_to_use || !!content.form && !!content.form.form_id;
  }
  return isCmv2 || !!(smartObjects && smartObjects.length) || SMART_CAPABLE_WIDGET_TYPES.includes(type);
};
export const getSmartRulesCount = module => module.has('smart_objects') ? module.get('smart_objects').size : 0;
export const getModuleHasSmartContent = module => module.get('definition_id') && getSmartRulesCount(module) > 0;
export const getModuleSmartRuleIds = module => (module.get('smart_objects') || List()).map(smartRule => smartRule.get('criterion_id')).toJS();